import React from "react";
import Welcome from "hearing/components/digits2/pre-test/welcome";
import Consent from "hearing/components/digits2/pre-test/consent";
import Hearing from "hearing/components/digits2/pre-test/hearing";
import DemoInfo from "hearing/components/digits2/pre-test/demo-info";
import VolumeAdjustment from "hearing/components/digits2/pre-test/adjustment";
import SpeechInNoise from "hearing/components/digits2/test/speech-in-noise";
import TestDemo from "hearing/components/digits2/test/test-demo";
import Environment from "hearing/components/digits2/pre-test/environment";
import Submit from "hearing/components/digits2/post-test/submit";
import axios from "axios";
import FontComponent from 'assets/font-ui';


class Main extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      participantId: null,
      studyId: null,
      withAids: null,
      process: "welcome",
      consent: {},
      email: "",
      hearing: {},
      volume: 0,
      output: null,
      SNR: null,
      reactTimer: null,
      realTimer: null
    };
  }

  componentDidMount = async () => {
    await axios.post('/api/hearing/visit', { page: 'hearing/crm/digits2' });
  };

  handleChangeId = (participantId, studyId) => {
    this.setState({participantId, studyId, process: "environment"});
  }

  handleConsentClick = (email) => {
    this.setState({ email, process: "demo-info" });
  };

  handleBirthClick = (birth) => {
    this.setState({ birth, process: "hearing" });
  };

  handleHearClick = async (hearing) => {
    await this.setState({ hearing, process: "environment" });
  };

  handleEnvironmentClick = () => {
    this.setState({ process: "adjustment" });
  };

  handleAdjustmentClick = (volume, output, withAids) => {
    this.setState({ process: "demo", volume, output, withAids });
  };

  handleDemoClick = () => {
    this.setState({ process: "testing" });
  };

  handleTestingClick = (SNR, reactTimer, realTimer, questions, answers, dbs) => {
    this.setState({ SNR, reactTimer, realTimer, questions, answers, dbs, process: "submit" });
  };

  handleSubmitClick = async () => {
    const {
      participantId, studyId, output, withAids, volume,
      SNR, reactTimer, realTimer, questions, answers, dbs
    } = this.state;
    await axios.post("/api/hearing/digits2/user", {
      participantId, studyId, output, withAids, volume,
      SNR, reactTimer, realTimer, questions, answers, dbs
    });
    window.location = "/";
  };

  renderProcess = () => {
    const { process, volume } = this.state;
    switch (process) {
      case "welcome":
        return <Welcome onChangeId={this.handleChangeId}/>;
      case "consent":
        return <Consent handleClick={this.handleConsentClick} />;
      case "demo-info":
        return <DemoInfo handleClick={this.handleBirthClick} />;
      case "hearing":
        return <Hearing handleClick={this.handleHearClick} />;
      case "environment":
        return <Environment handleClick={this.handleEnvironmentClick} />;
      case "adjustment":
        return (
          <VolumeAdjustment
            handleClick={this.handleAdjustmentClick}
          />
        );
      case "demo":
        return <TestDemo volume={volume} handleClick={this.handleDemoClick} />;
      case "testing":
        return (
          <SpeechInNoise
            volume={volume}
            handleClick={this.handleTestingClick}
          />
        );
      case "submit":
        return <Submit handleClick={this.handleSubmitClick} />;
      default:
        return null;
    }
  };

  render() {
    return (
    <div style={{
      backgroundColor: "rgb(240,240,240)",
      fontFamily: "raven",
      height: window.innerHeight,
      overflowY: "scroll",
      paddingRight: "5%"
    }}>
      <FontComponent />
      {this.renderProcess()}
    </div>
    )
  }
}

export default Main;
